import { IconButton } from '@material-ui/core';
import CircularProgress from "@mui/material/CircularProgress";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { ReactComponent as PlusIcon } from "assets/icons/plus.svg";
import sortImg from "assets/icons/sort-able-svg.svg";
import Action from "components/ActionPopOver";
import Button from 'components/button/Button';
import { debounce } from "lodash";
import React, { useCallback, useEffect, useState } from "react";
import { toastr } from "react-redux-toastr";
import { GroupSearch, GroupSearchButton, GroupSearchInput } from "../Theme.js";
import "./index.scss";


function ViewGroup({ closeDrawer, openAddGroup, groupsList, groupLoading, onDeleteGroupClick }) {
  const [formattedGroups, setFormattedGroups] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [sortValue, setSortValue] = useState("asc");
  const [isLoading, setIsLoading] = useState(false);


  const handleSearch = useCallback(
    debounce((value) => {
      setIsLoading(true);
      setSearchValue(value);
    }, 500),
    []
  );

  const handleSortToggle = () => {
    setSortValue((prevSortValue) => (prevSortValue === "asc" ? "desc" : "asc"));
  };


  useEffect(() => {
    if (groupsList) {
      setIsLoading(true);
      
      let filteredGroups = groupsList.filter((group) =>
        group?.label.toLowerCase().includes(searchValue.toLowerCase())
      );

      // Sorting
      if (sortValue === "asc") {
        filteredGroups.sort((a, b) => a.label.localeCompare(b.label));
      } else if (sortValue === "desc") {
        filteredGroups.sort((a, b) => b.label.localeCompare(a.label));
      }

      setFormattedGroups(filteredGroups);
      setIsLoading(false);
    }
  }, [searchValue, sortValue, groupsList]);





  return (
    <div className="view-group">
      <div className="group-text view-group__header update__user__header">
        <Typography variant="h5" gutterBottom className="title_name_group mb-0">
          Groups
        </Typography>
        <div className="user__header__action">
          <button
            className="cancel_user_btn"
            onClick={closeDrawer}
          >
            Cancel
          </button>
          <Button
              variant="primary"
              onClick={() => {
                openAddGroup();
              }}
              size="md"
          >
              <PlusIcon />
              <span>Add New Group</span>
          </Button>
        </div>
      </div>
      <GroupSearch>
        <GroupSearchInput 
          placeholder="Group Name" 
          onChange={(e) => handleSearch(e.target.value)}  // Debounced search
        />
        <IconButton onClick={handleSortToggle}>
          <img src={sortImg} alt="sort" className="" />
        </IconButton>
      </GroupSearch>


      <div className="group-names">
        {(isLoading || groupLoading) ? (
          <div className="d-flex justify-content-center align-items-center pt-10">
            <CircularProgress />
          </div>
        ) : !!formattedGroups?.length ? formattedGroups?.map((group) => (
          <div className="single-group-name" key={group?.value}>
            <span>{group?.label}</span>
            <div style={{ cursor: "pointer", paddingLeft: "0px" }}>
              <Action
                action='class'
                style={{ width: '16px' }}
                onEditViewClick={() => openAddGroup(group)}
                onClassDeleteClick={() => onDeleteGroupClick(group)}
              />
            </div>
          </div>
        )) : (
          <div className="d-flex justify-content-center align-items-center pt-10">
            <span>No groups found</span>
          </div>
        )}
        


      </div>

    </div>
  );
}

export default ViewGroup;
